import { createContext, ReactElement, useContext } from "react";

export interface IAppConfig {
  NODE_ENV: string;
  OKTA_APP_NAME: string;
  OKTA_CLIENT_ID: string;
  OKTA_AUTH_SERVER_URL: string;
  DATADOG_APPID: string;
  DATADOG_CLIENT_TOKEN: string;
  DATADOG_SESSION_REPLAY_SAMPLE_RATE: number;
  EXTRA_OKTA_AUTH_SCOPES: string;
  PROMOTION_SERVICE_URL: string;
  PREFERENCES_SERVICE_URL: string;
  CLAIMS_SERVICE_URL: string;
  RETURNS_SERVICE_URL: string;
  INVENTORY_SERVICE_URL: string;
  PRICING_SERVICE_URL: string;
  PARTS_SERVICE_URL: string;
  FEATURE_TOGGLE_SERVICE_URL: string;
  HANDLING_UNIT_SERVICE_URL: string;
  RBAC_SERVICE_URL: string;
  APP_SYNC_URL: string;
  ODATA_APIM_OMOPERATIONS_URL: string;
  DEALER_SERVICE_URL: string;
  SAP_SLA_URL: string;
  SAP_CARRIER_DETAILS_URL: string;
  SAP_CREDIT_DETAILS_URL: string;
  ORDERS_SERVICE_URL: string;
  VALIDATIONS_SERVICE_URL: string;
  XTREME_BFF_SERVICE_URL: string;
  INVOICE_SERVICE_URL: string;
  JOBS_SERVICE_URL: string;
  BROADCAST_MESSAGES_SERVICE_URL: string;
  APP_NOTIFICATION_SERVICE_URL: string;
  JDPO_JAVA_URL: string;
  JDPOINT_URL: string;
  PPT_REPORTS_BACKEND_URL: string;
  PPT_POWERBI_WORKSPACE_ID: string;
  PPT_POWERBI_REPORT_ID: string;
  PPT_POWERBI_DATASET_ID: string;
  PPT_ROLES: string;
  PSTS_URL: string;
  JDPOINT_INVCS_URL: string;
  MOCK_SERVICE_URL: string;
  DEALER_INVENTORY_LINK: string;
  JD_POINT_INVENTORY_LINK: string;
  ORDERS_BY_PART_LINK: string;
  OTHER_DEALER_INVENTORY_LINK: string;
  MY_LOCATOR_INVENTORY_LINK: string;
  MY_LOCATOR_ENTRY_LINK: string;
  EXPERT_CONNECT_LINK: string;
  CCMS_LINK: string;
  PARTS_ADVISOR_LINK: string;
  NMQ_LINK: string;
  PDG_LINK: string;
  PROPOSED_ORDERS_URL: string;
  JDPRISM_HOMEPAGE_URL: string;
  D2D_INVENTORY_API_URL: string;
  D2D_OTHER_DEALER_INVENTORY_API_URL: string;
  SUPPLIER_INVENTORY_URL: string;
  POLLING_INTERVAL: number;
  PROMOTION_DOWNLOAD_JOB_TIMEOUT: number;
  MAX_TOTAL_PARTS_FOR_EXCEL_DOWNLOAD: number;
  BROADCAST_MESSAGE_CUSTOM_TAG_MAX_LENGTH: number;
  NUMBER_OF_NOTIFICATIONS_TO_SHOW: number;
  ENABLE_PROMOTIONS_AUTHORIZATION: boolean;
  ENABLE_CLAIMS_AUTHORIZATION: boolean;
  ENABLE_RETURNS_AUTHORIZATION: boolean;
  ENABLE_CLAIMS: boolean;
  ENABLE_HANDLING_UNITS: boolean;
  ENABLE_HANDLING_UNITS_AUTHORIZATION: boolean;
  ENABLE_INVOICES_CONSOLIDATED: boolean;
  ENABLE_INVOICES_CONSOLIDATED_DOWNLOAD: boolean;
  ENABLE_INVOICES_VIEWED: boolean;
  ENABLE_ALL_INVOICES: boolean;
  ENABLE_INVOICE_DETAILS: boolean;
  ENABLE_INVOICE_DETAILS_V2: boolean;
  ENABLE_MAX_ORDER_LINES_UI_VALIDATION: boolean;
  ENABLE_PREFERENCES: boolean;
  ENABLE_FEATURE_TOGGLES: boolean;
  ENABLE_SUPER_ADMIN_FEATURE_TOGGLES: boolean;
  ENABLE_FEATURE_TOGGLE_SERVICE_INTEGRATION: boolean;
  ENABLE_ALL_FEATURE_TOGGLE_STATUS: boolean;
  ENABLE_PREFERENCES_SAVE_BUTTONS: boolean;
  ENABLE_DEALER_CONTEXT_V2: boolean;
  ENABLE_FEATURE_TOGGLE_CONTEXT_V2: boolean;
  ENABLE_SURPLUS_RETURNS: boolean;
  ENABLE_CORE_RETURNS: boolean;
  ENABLE_ACCOUNT_LOCATION_FALLBACK: boolean;
  ENABLE_MY_DASHBOARD_PROMOTION_CARD: boolean;
  ENABLE_MY_DASHBOARD_ORDERS_CARD: boolean;
  ENABLE_MY_DASHBOARD_ORDERS_METRIC_CARD: boolean;
  ENABLE_SENT_TO_FACTORY_STATUS: boolean;
  CONSOLIDATED_PRICE_API_BATCH_SIZE: number;
  CONSOLIDATED_PRICE_API_MAX_PARALLEL_CALLS: number;
  ENABLE_CREDIT_STATUS: boolean;
  ENABLE_HU_FOR_INVOICES: boolean;
  ENABLE_LEGACY_REDIRECT_ALL_INVOICES: boolean;
  ENABLE_LEGACY_REDIRECT_HU: boolean;
  ENABLE_LEGACY_REDIRECT_CLAIMS: boolean;
  ENABLE_CORPORATE_VIEW: boolean;
  ENABLE_CORE_ELIGIBILITIES: boolean;
  ENABLE_CLAIMS_CHINA: boolean;
  ENABLE_CLAIMS_INDIA: boolean;
  ENABLE_RBAC_INTEGRATION: boolean;
  ENABLE_INVOICE_LEADING_ZEROS: boolean;
  ENABLE_INVOICE_DETAILS_PORTLAND_SURCHARGE: boolean;
  ENABLE_FT_RBAC_INTEGRATION: boolean;
  ENABLE_SAP_CANCELLED_INVOICE: boolean;
  ENABLE_NEW_HU_TRACKING_LINK: boolean;
  ENABLE_CORE_PRICE: boolean;
  ENABLE_CONSOLIDATION_FOR_MULTIPLE_ACCOUNTS: boolean;
  ENABLE_BFF_SERVICE: boolean;
  ENABLE_FILTER_ENHANCEMENTS: boolean;
  ENABLE_VENDOR_DIRECT_INVOICE: boolean;
  ENABLE_PROMOTIONS_COLUMN_ALL_ORDERS_V2: boolean;
  ENABLE_ALL_ORDERS_PROMOTION_SORT_FILTER: boolean;
  ENABLE_ALL_ORDERS_V2_OPTIMIZATIONS: boolean;
  ENABLE_ORDER_SUMMARY_DOWNLOAD_V2: boolean;
  ENABLE_NEW_BMS_CHAR_LIMIT_CONSTRAINT: boolean;
  ENABLE_DEALER_V2: boolean;
  ENABLE_ASYNC_ALL_ORDERS_DOWNLOAD: boolean;
  ENABLE_V2_ADDRESS_VALIDATION: boolean;
  ENABLE_ADDRESS_CONFIRMATION_CHECKBOX: boolean;
  ENABLE_ZIP_CODE_SPACES: boolean;
  ENABLE_ASYNC_ORDERS_BY_LINE_ITEM_DOWNLOAD: boolean;
  DELETE_EXPIRED_NOTIFICATIONS: boolean;
  NOTIFICATION_EXPIRY_DAYS: number;
  ENABLE_ORDER_SUMMARY_HEADER_ENHANCEMENTS: boolean;
  ORDER_DATE_FILTER_ENHANCEMENT: boolean;
  CORE_SHIPPING_INSTRUCTIONS_URL: string;
  SURPLUS_SHIPPING_INSTRUCTIONS_URL: string;
  DAILY_SHIPPING_INSTRUCTIONS_URL: string;
  USE_BFF_PREFERENCES_ENDPOINT: boolean;
  ENABLE_RBAC_AUTH_SUPPORT: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_BROADCAST_MESSAGE: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_INVENTORY: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_PROMOTIONS: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_PRICING: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_PARTS: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_PREFERENCES: boolean;
  ENABLE_DYNAMIC_PROMOTION_FEATURE_TOGGLE: boolean;
  ENABLE_INVOICES_V2: boolean;
  ENABLE_SHIP_UNIT_DESCRIPTION: boolean;
  ENABLE_SLA_DESCRIPTION: boolean;
  ENABLE_HANDLING_UNITS_V2: boolean;
  ENABLE_INVOICE_LINE_ITEMS_EXCEL_DOWNLOAD: boolean;
  ENABLE_DYNAMIC_EXTERNAL_LINKS_FEATURE_TOGGLE: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_RETURNS_SERVICE: boolean;
  ENABLE_RPM_FOR_JDPRISM_LINKS: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_JOBS_SERVICE: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_FEATURE_TOGGLE_SERVICE: boolean;
  ENABLE_RBAC_ROLES_V2: boolean;
  ENABLE_VIEW_ONLY_BROADCAST_MESSAGES_FOR_JD_DEVELOPER_ADMIN_AND_JD_READ_ONLY: boolean;
  ENABLE_BACKORDERS_ACCORDION: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_CLAIMS_SERVICE: boolean;
  ENABLE_ORDER_SERVICE_BFF: boolean;
  ENABLE_UNIQUE_LINE_ID_UPDATE_ON_SAVE: boolean;
  ENABLE_BACKORDER_FOR_SUBLINE_SLA: boolean;
  ENABLE_CLAIMS_CREDIT_DEBIT: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_ORDER_SERVICE: boolean;
  ENABLE_FEEDBACK_COMPONENT: boolean;
  ENABLE_PROMOTIONS_V2: boolean;
  ENABLE_ALL_ORDERS_TABLE_TAB: boolean;
  ENABLE_APP_NOTIFICATIONS: boolean;
  ENABLE_BROADCAST_MESSAGE_NOTIFICATIONS: boolean;
  ENABLE_REPORTS: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_ELIGIBILITIES_SERVICE: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_HANDLING_UNIT_SERVICE: boolean;
  ENABLE_REMOVE_DASHBOARD_TAB: boolean;
  ENABLE_INVOICE_EXCEL_DOWNLOAD_V2: boolean;
  ENABLE_MULTIPLE_ACCOUNTS: boolean;
  ENABLE_MULTIPLE_ACCOUNTS_SELECTION_DROPDOWN: boolean;
  DISABLE_PROMOTIONS_V2_DOWNLOAD_AND_TOOLTIP: boolean;
  ENABLE_NAVIGATION_WITH_USEEFFECT: boolean;
  ENABLE_DASHBOARD_WIDGETS_V2: boolean;
  ENABLE_CLAIMS_V2_PRICE_CALCULATION: boolean;
  ENABLE_INVOICES_LINE_ITEM_PART_DESCRIPTION_TRANSLATION: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_APP_NOTIFICATION: boolean;
  ENABLE_D2D: boolean;
  ENABLE_DOWNLOAD_ALL_ORDERS_EXCEL_WITH_FILTERS: boolean;
  ENABLE_CPM_FOR_CLAIMS: boolean;
  ENABLE_EMPTY_MAPPING_ACCOUNT_HANDLING: boolean;
  ENABLE_ACCOUNT_SELECTION_ON_ORDER_CREATE: boolean;
  ENABLE_ACCOUNT_ID_READ_ONLY: boolean;
  ENABLE_ALL_ORDERS_TAB_COUNT_STABILIZATION: boolean;
  ENABLE_HIDING_FUTURE_DATED_PROMOTIONS_IN_ORDER_CREATION: boolean;
  ENABLE_ALL_PARTS_PROMOTION_ENHANCEMENT: boolean;
  ENABLE_ALL_PARTS_PROMO_DETAILS: boolean;
  ENABLE_REMITO_NUMBER_FOR_ARGENTINA: boolean;
  ENABLE_REMITO_DOWNLOAD: boolean;
  ENABLE_FIX_FOR_SORTING_DEALER_ACCOUNT_COLUMN: boolean;
  ENABLE_OKTA_SCOPES: boolean;
  ENABLE_ARGENTINA_INVOICEPDF: boolean;
  ENABLE_DEALER_NAME_SORT_FOR_CPM: boolean;
  ENABLE_DEALER_ID_COLUMN_PERSISTENCE_IN_HU: boolean;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_DEALER_SERVICE: boolean;
  ENABLE_CLAIMS_AND_RETURNS_NAV: boolean;
  ENABLE_CONSOLIDATION_METHOD_PREFERENCE: boolean;
  ENABLE_ORDERS_AND_TRACKING_MENU: boolean;
  ENABLE_STORAGE_LOCATION: boolean;
  ENABLE_DEALER_PATH_FOR_CLAIMS: boolean;
  MAX_ORDER_LINES: number;
  ENABLE_RBAC_AUTH_SUPPORT_FOR_VALIDATIONS_SERVICE: boolean;
  ENABLE_ORDERS_BY_LINE_ITEM_DATE_TIME_CREATED_FILTER: boolean;
  ENABLE_NEW_SLA_DATA_FOR_PRICING: boolean;
  ENABLE_OPTIMIZED_ALL_ORDERS: boolean;
  ENABLE_DEALER_ID_COLUMN_FOR_MULTIPLE_ACCOUNTS_FOR_PROMOTIONS: boolean;
  ENABLE_ORDERS_BY_LINE_ITEM_TABLE_TAB: boolean;
  ENABLE_LINE_COUNT_AGGREGATED_QUERY: boolean;
  ENABLE_USE_ORDER_RESPONSE_CURRENCY_CODE: boolean;
  ENABLE_CONSOLIDATE_INVOICES_TO_EXCEL: boolean;
  ENABLE_CORPORATE_VIEW_DPA_ROLE: boolean;
  ENABLE_DAILY_RETURN_WITH_DEALER_PREPARATION: boolean;
  ENABLE_DASHBOARD_RETURNS_DEALER_PREPARATION: boolean;
  ENABLE_ESTIMATED_RETURN_VALUE: boolean;
  ENABLE_JDPS_POSTSHIP_ACTIVITIES: boolean;
  ENABLE_JDPS_SURPLUS_RETURN_ACTIVITIES: boolean;
  ENABLE_RETURNS_ACCOUNT_STATE_NAVIGATION: boolean;
  ENABLE_D2D_ORDER_REQUEST_NEED_ACTION_ALERT: boolean;
  ENABLE_ALL_ORDERS_PERSIST_FILTER_ON_SESSION: boolean;
  ENABLE_ALL_ORDERS_PERSIST_COLUMNS_ON_SESSION: boolean;
  ENABLE_ALL_ORDERS_COLUMN_USER_PREFERENCE: boolean;
  ENABLE_ORDERS_BY_LINE_USER_PREFERENCE: boolean;
  ENABLE_ORDERS_BY_LINE_PERSIST_COLUMNS_ON_SESSION: boolean;
  ENABLE_INVOICE_PERSIST_FILTER_ON_SESSION: boolean;
  ENABLE_PROMOTION_SCALES_ACCORDION: boolean;
  ENABLE_EU_DEALER_LEGACY_PRICE: boolean;
  ENABLE_HU_PERSIST_FILTER_ON_SESSION: boolean;
  ENABLE_RBAC_NO_ROLES_HANDLING: boolean;
  ENABLE_ORDER_TYPE_FILTER_FOR_SHIPPING_ADDRESSES: boolean;
  ENABLE_V3_SALES_DETAILS_INTEGRATION: boolean;
  ENABLE_INVESTIGATION_MESSAGES_FOR_ORDER_LINE_ITEMS: boolean;
  ENABLE_DATADOG_RUM: boolean;
  ENABLE_DATADOG_UNHANDLED_REJECTION_GUARD: boolean;
  ENABLE_ASYNC_DOWNLOAD_WITH_SCALES: boolean;
  ENABLE_ROUTE_TO_DEALER: boolean;
  ENABLE_DAILY_SURPLUS_ALERT_AND_NOTIFICATION: boolean;
  ENABLE_DAILY_SCRAP_CREDIT_PENDING?: boolean;
  ENABLE_DYNAMIC_HIDE_PROMO_DISC_INFO_FEATURE_TOGGLE: boolean;
  ENABLE_LINE_LEVEL_SCALE_COLUMNS: boolean;
  ENABLE_LCP_OPTIMISATION_ORDER_CREATION: boolean;
  ENABLE_LCP_OPTIMISATION_RETURNS_LIST: boolean;
  ENABLE_ALL_RETURNS_EXCEL_DOWNLOAD: boolean;
  ENABLE_DELEGATE_LOGIN: boolean;
  ENABLE_GEO_RESTRICTION_MESSAGE: boolean;
  ENABLE_INTERNATIONAL_RETURN: boolean;
}

export interface WindowWithAppConfig extends Window {
  APP_CONFIG?: IAppConfig;
}

export const ConfigContext = createContext<IAppConfig>({} as IAppConfig);
export const useConfigContext = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }: { children: ReactElement }) => {
  const config =
    (window as WindowWithAppConfig).APP_CONFIG || ({} as IAppConfig);
  const updatedConfig: IAppConfig = {
    ...config,
    ENABLE_CORPORATE_VIEW:
      config.ENABLE_CORPORATE_VIEW && config.ENABLE_RBAC_INTEGRATION,
  };
  return (
    <ConfigContext.Provider value={updatedConfig}>
      {children}
    </ConfigContext.Provider>
  );
};
